const phoneNumber = /^(?:\+\d{1,3}\s)?(\d{3}\s\d{3}\s\d{3}|\d{9})$/;
const email = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[\w-]+$/i;

export const regex = {
  phoneNumber,
  email,
};
